<template>
  <h1 class="display-1 font-weight-light decorated mb-4">
    <slot/>
  </h1>
</template>

<script>
export default {
  name: 'base-title',
}
</script>
